module.exports = __webpack_public_path__ + "img/qingdao_tu.7384ce5a.png";